import { Injectable } from "@angular/core";

import { HttpClient, XhrFactory } from "@angular/common/http";

import { Observable } from "rxjs";

import { map } from "rxjs/operators";

import { HttpHeaders } from '@angular/common/http';

import { AppConfig } from '../../app.config';

import { GlobalVariable } from '../../app.globalvariable';

import { PacsInfo } from '../../model/pacsinfo.model'
import { SearchInfo } from '../../model/searchinfo.model';
import { NgForm } from "@angular/forms";
import { PacsEntry } from "src/app/model/pacsentry.model";
import { CommonEncrypt } from "../../utils/common.encrypt";
import { SampleInfo } from "src/app/model/sampleInfo.model";
// import { SampleInfo } from '../../model/sampleInfo.model';

@Injectable()

export class HttpServices {

    baseUrl: string;

    debugParam: string = "";  //debug参数 

    sessionID: string = "";

    constructor(private http: HttpClient) {

        this.baseUrl = GlobalVariable.getBaseUrl();

    }


    authenticate1(mobile: string, pass: string): Observable<string> {

        return this.http.post<any>(`${this.baseUrl}user/login` + this.getDebugParam(),

            { mobile: mobile, password: pass }, this.getOptions());

    }

    //随机
    random(): Observable<any> {
        var aa = this.http.post<any>(`${this.baseUrl}common/random` + this.getInitDebugParam(), this.getOptions());
        return aa;
    }

    download(type): Observable<any> {
        return this.http.post<any>(`${this.baseUrl}download` + this.getDebugParam(), {
            type: type
        }, this.getOptions());
    }

    studyInit(initInfo: SampleInfo): Observable<any> {

        // return this.http.post<any>(this.baseUrl + "user/studyInit" + this.getDebugParam(),

        // initInfo, this.getOptions());
        return this.http.post<any>(`${this.baseUrl}user/studyInit` + this.getDebugParam(),
            initInfo, this.getOptions());

    }

    examResult(paramInfo): Observable<any> {
        return this.http.post<any>(`${this.baseUrl}user/examResult` + this.getDebugParam(),
            paramInfo, this.getOptions());
    }


    savePacsInfo(pacsInfo: PacsInfo): Observable<any> {

        return this.http.post<any>(this.baseUrl + "addPatient" + this.getDebugParam(),

            pacsInfo, this.getOptions());

    }



    deletePatient(id: string): Observable<any> {

        return this.http.post<any>(`${this.baseUrl}deletePatient` + this.getDebugParam(),

            { P_ID: id }, this.getOptions());

    }

    deleteFile(pid, fid): Observable<any> {

        return this.http.post<any>(`${this.baseUrl}deletePacsFile` + this.getDebugParam(),

            { P_ID: pid, F_ID: fid }, this.getOptions());

    }

    //首页菜单
    getMenuList(): Observable<any> {
        return this.http.get<any>(`${this.baseUrl}user/menuList` + this.getDebugParam(), this.getOptions());
    }

    submitPasswd(passwd: any): Observable<any> {
        return this.http.post<any>(`${this.baseUrl}user/changePassword` + this.getDebugParam(),
            passwd, this.getOptions());
    }

    forgetPasswd(passwd: any): Observable<any> {
        return this.http.post<any>(`${this.baseUrl}user/getPassword` + this.getDebugParam(),
            passwd, this.getOptions());
    }

    getHomePageInfo(type: any): Observable<any> {
        return this.http.post<any>(`${this.baseUrl}joint/large` + this.getDebugParam(),
            {
                type: type
            }, this.getOptions());
    }

    submitData(data: any): Observable<any> {
        return this.http.post<any>(`${this.baseUrl}joint/saveData` + this.getDebugParam(),
            {
                data: data
            }, this.getOptions());
    }

    getDetail(patientId: any, visitNo: any, type: any): Observable<any> {
        return this.http.post<any>(`${this.baseUrl}joint/detail` + this.getDebugParam(),
            {
                patientId: patientId,
                visitNo: visitNo,
                type: type
            }, this.getOptions());
    }

    // 通过姓名检索
    search(searchType: number, patientName: string, id: any): Observable<any> {
        return this.http.post<any>(`${this.baseUrl}joint/search` + this.getDebugParam(),
            {
                type: searchType,
                name: patientName,
                id: id
            }, this.getOptions());
    }

    getJointInfo(patientId: number, visitNo: number): Observable<any> {
        return this.http.post<any>(`${this.baseUrl}joint/getJointInfo` + this.getDebugParam(),
            {
                patientId: patientId,
                visitNo: visitNo
            }, this.getOptions());
    }



    getCaseData(patientId: number, visitNo: number): Observable<any> {
        return this.http.post<any>(`${this.baseUrl}joint/getCaseData` + this.getDebugParam(),
            {
                patientId: patientId,
                visitNo: visitNo
            }, this.getOptions());
    }

    getSsData(patientId: number, visitNo: number): Observable<any> {
        return this.http.post<any>(`${this.baseUrl}ss/getMatchResult` + this.getDebugParam(),
            {
                patientId: patientId,
                visitNo: visitNo
            }, this.getOptions());
    }

    getSleData(patientId: number, visitNo: number): Observable<any> {
        return this.http.post<any>(`${this.baseUrl}sle/getMatchResult` + this.getDebugParam(),
            {
                patientId: patientId,
                visitNo: visitNo
            }, this.getOptions());
    }

    saveSsData(correctSsSum, patientId, visitNo, gland, ssa, oss, schirmer, uws, patientName, sex, age, id): Observable<any> {
        return this.http.post<any>(`${this.baseUrl}ss/saveMatchResult` + this.getDebugParam(),
            {
                score: correctSsSum,
                patientId: patientId,
                visitNo: visitNo,
                gland: gland,
                ssa: ssa,
                oss: oss,
                schirmer: schirmer,
                uws: uws,
                patientName: patientName,
                sex: sex,
                age: age,
                id: id
            }, this.getOptions());
    }

    getConnector(type: any): Observable<any> {
        return this.http.post<any>(`${this.baseUrl}setting/getConnector` + this.getDebugParam(), {
            type: type
        }, this.getOptions());
    }

    getSsSettingDatas(): Observable<any> {
        return this.http.post<any>(`${this.baseUrl}setting/getSsSettingDatas` + this.getDebugParam(), this.getOptions());
    }

    getSaveData(patientId: any, visitNo: any): Observable<any> {
        return this.http.post<any>(`${this.baseUrl}ss/getSavedData` + this.getDebugParam(), {
            'patient_id': patientId,
            'visit_no': visitNo
        }, this.getOptions());
    }

    getSleSaveData(patientId: any, visitNo: any): Observable<any> {
        return this.http.post<any>(`${this.baseUrl}sle/getSavedData` + this.getDebugParam(), {
            'patient_id': patientId,
            'visit_no': visitNo
        }, this.getOptions());
    }

    getSsDetail(patientId: any, visitNo: any, type): Observable<any> {
        return this.http.post<any>(`${this.baseUrl}ss/getSsDetail` + this.getDebugParam(), {
            'patient_id': patientId,
            'visit_no': visitNo,
            'type': type
        }, this.getOptions());
    }

    getSleDetail(patientId: any, visitNo: any, type): Observable<any> {
        return this.http.post<any>(`${this.baseUrl}sle/getSleDetail` + this.getDebugParam(), {
            'patient_id': patientId,
            'visit_no': visitNo,
            'type': type
        }, this.getOptions());
    }


    time(type: number, id: number): Observable<any> {
        return this.http.post<any>(`${this.baseUrl}joint/patientList` + this.getDebugParam(),
            {
                type: type,
                id: id
            }, this.getOptions());
    }


    // 登录
    signin(username, password, organ): Observable<any> {
        return this.http.post<any>(`${this.baseUrl}login` + this.getDebugParam(), {
            username: username,
            password: password,
            'organ_id': organ
        }, this.getOptions());
    }

    getUserOrgan(): Observable<any> {
        return this.http.post<any>(`${this.baseUrl}getUserOrgan` + this.getDebugParam(), this.getOptions());
    }

    checkOrg(username, password): Observable<any> {
        return this.http.post<any>(`${this.baseUrl}loginBefore` + this.getDebugParam(), {
            username: username,
            password: password
        }, this.getOptions());
    }

    saveCustomData(date, goodsList): Observable<any> {
        return this.http.post<any>(`${this.baseUrl}saveGoodsData` + this.getDebugParam(), {
            'date': date,
            'goodsData': goodsList
        }, this.getOptions());
    }

    getDataByDateChange(myDates, goodsList): Observable<any> {
        return this.http.post<any>(`${this.baseUrl}getDataByDateChange` + this.getDebugParam(), {
            'date': myDates,
            'goodsData': goodsList
        }, this.getOptions());
    }

    // 获取上次选择过的商品数据
    getLastGoodsData(goodsList, date): Observable<any> {
        return this.http.post<any>(`${this.baseUrl}getLastGoodsData` + this.getDebugParam(), {
            'goods': goodsList,
            'date': date
        }, this.getOptions());
    }


    getLastGoodsUpdateTime(): Observable<any> {
        return this.http.post<any>(`${this.baseUrl}getLastUpdateTime` + this.getDebugParam(), this.getOptions());
    }

    // uploadFile(formData): Observable<any> {
    //     let url = this.baseUrl + 'uploadFile' + this.getDebugParam();
    //     return Observable.create(function (observer) {
    //         let xhr = new XMLHttpRequest();
    //         xhr.onreadystatechange = function () {
    //             if (xhr.readyState == 4) {
    //                 if (xhr.status == 200) {
    //                     observer.next(xhr.response);
    //                 } else {
    //                     observer.error(xhr.response);
    //                 }
    //             }
    //         };

    //         xhr.open("POST", url, true);
    //         //xhr.setRequestHeader(header.name, header.value);
    //         xhr.send(formData);
    //     });
    // }

    searchGoods(goodsData, date): Observable<any> {
        return this.http.post<any>(`${this.baseUrl}getSourceGoodsData` + this.getDebugParam(), {
            prodName: goodsData,
            date: date
        }, this.getOptions());
    }

    getSelectedGoodsData(goodsIds, date): Observable<any> {
        return this.http.post<any>(`${this.baseUrl}getGoodsSourceDataById` + this.getDebugParam(), {
            'goodsIds': goodsIds,
            'date': date
        }, this.getOptions());
    }

    // 入组
    groupList(): Observable<any> {
        return this.http.post<any>(`${this.baseUrl}statistic/group` + this.getDebugParam(), this.getOptions());
    }

    private getOptions() {

        return {

            headers: new HttpHeaders({

                // "Authorization": `Bearer<${GlobalVariable.getAuthToken()}>`,
                // "Userid" : GlobalVariable.getUserID(),
                // "Organid" : GlobalVariable.getOrganID()

            })

        }

    }


    /**
     * 获取初始化的全局参数 
     * (适用于首次连接服务器，建立session的情况)
     */
    public getInitDebugParam() {
        this.debugParam = "";
        let otherParam: string = null;       //其他参数    

        if (AppConfig.isDebug()) {
            this.debugParam = "?XDEBUG_SESSION_START=PHPSTORM";
        }
        otherParam = this.getOtherParam(false);

        return this.debugParam + "&params=" + otherParam;
    }

    /**
     * 获取请求接口的全局参数
     * (适用于已连接服务器，session已存在的情况)
     */
    public getDebugParam() {
        let sessionIndex: number = 0;
        let otherParam: string = null;       //其他参数     

        sessionIndex = this.debugParam.indexOf('PHPSESSID=');
        if (sessionIndex < 0 || (sessionIndex >= 0 && this.sessionID != GlobalVariable.getSessionID())) {
            this.sessionID = GlobalVariable.getSessionID();
            if (this.sessionID != "") {
                this.debugParam = "?PHPSESSID=" + this.sessionID;
                if (AppConfig.isDebug()) {
                    this.debugParam = this.debugParam + "&XDEBUG_SESSION_START=PHPSTORM";
                }
            } else {
                if (AppConfig.isDebug()) {
                    this.debugParam = "?XDEBUG_SESSION_START=PHPSTORM";
                }
            }
        }
        otherParam = this.getOtherParam(true);

        return this.debugParam + "&params=" + otherParam;
    }

    /**
     * 获取其他全局参数 
     * @param isCheckToken 是否校验Token的标志位     
     */
    private getOtherParam(isCheckToken: boolean) {
        let otherParam: string = null;       //其他参数 
        let signData: string = null;         //签名数据 
        let deviceID: string = null;         //设备ID 
        let appVersionNo: string = null;     //APP版本号          
        let timeStamp: string = null;        //时间戳 
        let dateTemp: Date = null;
        let macKey: string = null;           //加密用随机字符串 

        //增加其他全局参数 （params:设备ID,版本号,签名数据,用户token,时间戳）
        deviceID = GlobalVariable.getDeviceID();
        appVersionNo = AppConfig.getVersionNo();
        dateTemp = new Date();
        timeStamp = dateTemp.getMilliseconds().toString();

        if (isCheckToken) {
            macKey = GlobalVariable.getMacKey();
        } else {
            macKey = '3968412890132567';
        }
        appVersionNo = appVersionNo.split(".").join("");

        //编辑签名数据 
        signData = `${deviceID}${appVersionNo}${timeStamp}${macKey}`;
        //加密签名 
        signData = CommonEncrypt.getHmacMD5Code(signData.toLowerCase(), macKey);

        otherParam = `deviceID=${deviceID}&appVersionNo=${appVersionNo}&timeStamp=${timeStamp}`;
        otherParam = CommonEncrypt.encryptData(otherParam, macKey);

        //增加token参数 
        if (isCheckToken) {
            otherParam = otherParam + `&token=${GlobalVariable.getToken()}` + `&sign=${signData}`;
        } else {
            otherParam = otherParam + `&sign=${signData}`;
        }
        return otherParam;
    }

    //获取患者的所有处方信息
    pacsInfo(searchObj): Observable<any> {
        //return this.http.get<any>(`${this.baseUrl}patientList/${searchStr}/${pageNum}/${onePageCount}` + this.getDebugParam(),this.getOptions());
        return this.http.post<any>(`${this.baseUrl}patientList` + this.getDebugParam(),
            searchObj, this.getOptions());

    }

    //获取患者的所有处方信息
    submitFiles(formData): Observable<PacsEntry> {
        const header: HttpHeaders = new HttpHeaders();
        header.set('Content-Type', 'multipart/form-data');
        header.set('Cache-Control', 'no-cache');
        return this.http.post<any>("http://wpacs.criponline.com:801/webpacs/wpsudp.aspx?user=cc&pswd=dd",
            formData, { reportProgress: true, headers: header });

    }

    insertFilesInfo(pacsOfPatient): Observable<any> {
        //return this.http.get<any>(`${this.baseUrl}patientList/${searchStr}/${pageNum}/${onePageCount}` + this.getDebugParam(),this.getOptions());
        return this.http.post<any>(`${this.baseUrl}savePacsFileInfo` + this.getDebugParam(),
            pacsOfPatient, this.getOptions());

    }

    searchPatientList(searchObj): Observable<any> {
        //return this.http.get<any>(`${this.baseUrl}patientList/${searchStr}/${pageNum}/${onePageCount}` + this.getDebugParam(),this.getOptions());
        return this.http.post<any>(`${this.baseUrl}cripPatientList` + this.getDebugParam(),
            searchObj, this.getOptions());

    }

    /**
     * 获取注册初始化信息
     * @returns 注册初始化信息 
     */
    getRegisterInitInfo(): Observable<any> {
        return this.http.post<any>(`${this.baseUrl}user/registerInit` + this.getDebugParam(),
            null, this.getOptions());
    }

    /**
    * 获取验证码信息
    * @param searchInfo 【手机、获取验证码类别】信息 
    * @returns 医院列表 
    */
    sendVerCode(searchInfo: any): Observable<any> {
        return this.http.post<any>(`${this.baseUrl}vercode/sendvercode` + this.getDebugParam(),
            searchInfo, this.getOptions());
    }


    /**
     * 根据省份Code取得市区列表
     * @param searchInfo 省份Code信息
     * @returns 市区列表 
     */
    getCityListByProvince(searchInfo: any): Observable<any> {
        return this.http.post<any>(`${this.baseUrl}user/getCityListByProvince` + this.getDebugParam(),
            searchInfo, this.getOptions());
    }

    /**
     * 根据省市信息取得医院列表信息
     * @param searchInfo 省市信息
     * @returns 医院列表 
     */
    getHospitalListByProvinceCity(searchInfo: any): Observable<any> {
        return this.http.post<any>(`${this.baseUrl}user/getHospitalListByProvinceCity` + this.getDebugParam(),
            searchInfo, this.getOptions());
    }

    /**
     * 保存注册信息 
     * @param userInfo 注册信息
     * @returns 执行结果 
     */
    saveRegisterInfo(userInfo: any): Observable<any> {
        return this.http.post<any>(`${this.baseUrl}user/saveRegisterInfo` + this.getDebugParam(),
            userInfo, this.getOptions());
    }

    /**
     * 获取用户个人信息
     * @returns 用户个人信息 
     */
    getPersonalInfo(): Observable<any> {
        return this.http.post<any>(`${this.baseUrl}user/getPersonalInfo` + this.getDebugParam(),
            null, this.getOptions());
    }

    /**
    * 保存用户个人信息 
    * @param userInfo 用户个人信息 
    * @returns 执行结果 
    */
    savePersonalInfo(userInfo: any): Observable<any> {
        return this.http.post<any>(`${this.baseUrl}user/savePersonalInfo` + this.getDebugParam(),
            userInfo, this.getOptions());
    }


    // 注册

    register(personalProfile): Observable<any> {

        return this.http.post<any>(`${this.baseUrl}user/register` + this.getDebugParam(),

            personalProfile, this.getOptions());


    }

    // 保存设置数据

    saveSettingData(id, ID, ALIAS, alias, form, min, max, title, title_other): Observable<any> {

        return this.http.post<any>(`${this.baseUrl}setting/saveSettingData` + this.getDebugParam(),
            {
                id: id,
                ID: ID,
                ALIAS: ALIAS,
                alias: alias,
                form: form,
                min: min,
                max: max,
                title: title,
                title_other: title_other
            }, this.getOptions());


    }

    // 设置诊断语句连接符

    setConnector(sign, type): Observable<any> {
        return this.http.post<any>(`${this.baseUrl}setting/setConnector` + this.getDebugParam(),
            {
                sign: sign,
                type: type
            }, this.getOptions());
    }

    // 修改密码

    resetPassword(password, psw1, psw2, userId): Observable<any> {
        return this.http.post<any>(`${this.baseUrl}setting/resetPassword` + this.getDebugParam(),
            {
                password: password,
                psw1: psw1,
                psw2: psw2,
                userId: userId
            }, this.getOptions());
    }



    getData(): Observable<any> {
        return this.http.post<any>(`${this.baseUrl}home` + this.getDebugParam(), this.getOptions());
    }

    insertData(review, specialScore, scoreReview, isUpdate, id): Observable<any> {

        return this.http.post<any>(`${this.baseUrl}review/insertData` + this.getDebugParam(),
            {
                data: review,
                specialScore: specialScore,
                score: scoreReview,
                isUpdate: isUpdate,
                id: id
            }, this.getOptions());

    }

    insertTable(type, data, doctorList, scoreSpecial, isUpdate, id, review, score): Observable<any> {

        return this.http.post<any>(`${this.baseUrl}review/insertTable` + this.getDebugParam(),
            {
                type: type,
                review: review,
                score: score,
                data,
                doctorList: doctorList,
                itemSpecial: scoreSpecial,
                isUpdate: isUpdate,
                id: id
            }, this.getOptions());

    }

    getDataSle(): Observable<any> {
        return this.http.post<any>(`${this.baseUrl}review/getData` + this.getDebugParam(), this.getOptions());
    }



    getNewsDetail(id): Observable<any> {
        return this.http.post<any>(`${this.baseUrl}newsDetail` + this.getDebugParam(), {
            id: id
        }, this.getOptions());
    }

    getNoticeDetail(id): Observable<any> {
        return this.http.post<any>(`${this.baseUrl}noticeDetail` + this.getDebugParam(), {
            id: id
        }, this.getOptions());
    }

    moreNotice(page): Observable<any> {
        console.log(1111)
        return this.http.post<any>(`${this.baseUrl}getMoreNotice` + this.getDebugParam(), {
            page: page
        }, this.getOptions());
    }

    sendSms(mobile, type): Observable<any> {
        console.log(type)
        return this.http.post<any>(`${this.baseUrl}sendSms` + this.getDebugParam(), {
            mobile: mobile,
            type: type
        }, this.getOptions());
    }

    getArea(area): Observable<any> {
        console.log(1111)
        return this.http.post<any>(`${this.baseUrl}getArea` + this.getDebugParam(), {
            keyWord: area
        }, this.getOptions());
    }

    getHospital(keyword, area): Observable<any> {

        return this.http.post<any>(`${this.baseUrl}getHospital` + this.getDebugParam(), {
            keyword: keyword,
            area: area
        }, this.getOptions());
    }

    changePassword(mobile, code, password): Observable<any> {

        return this.http.post<any>(`${this.baseUrl}user/changePassword` + this.getDebugParam(), {
            mobile: mobile,
            code: code,
            password: password
        }, this.getOptions());
    }

    downloadFile(type): Observable<any> {
        return this.http.post<any>(`${this.baseUrl}downloadFile` + this.getDebugParam(), {
            type: type
        }, this.getOptions());
    }

    uploadFile(fileToUpload, type): Observable<any> {
        const formData: FormData = new FormData();
        formData.append('file', fileToUpload, fileToUpload.name);

        let url = "";

        if (type == '1') {
            url = "uploadFileForm";
        } else if (type == '2') {
            url = "uploadFileMaterial";
        }

        return this.http.post<any>(`${this.baseUrl}` + url + this.getDebugParam(), formData, this.getOptions());
    }


    uploadImgs(file): Observable<any> {

        const formData: FormData = new FormData();
        formData.append('file', file, file.name);

        return this.http.post<any>(`${this.baseUrl}uploadImgs` + this.getDebugParam(), formData, this.getOptions());
    }


    login(username, password, type): Observable<any> {

        return this.http.post<any>(`${this.baseUrl}user/login` + this.getDebugParam(), {
            username: username,
            password: password,
            type: type
        }, this.getOptions());
    }


    userHandle(id, type, reason): Observable<any> {

        return this.http.post<any>(`${this.baseUrl}userHandle` + this.getDebugParam(), {
            id: id,
            type: type,
            reason: reason
        }, this.getOptions());
    }


    logout(): Observable<any> {
        return this.http.post<any>(`${this.baseUrl}user/logout` + this.getDebugParam(), this.getOptions());
    }


    uploadImg(file): Observable<any> {

        const formData: FormData = new FormData();
        formData.append('file', file, file.name);

        return this.http.post<any>(`${this.baseUrl}uploadImg` + this.getDebugParam(), formData, this.getOptions());
    }



    uploadImgForEditor(file): Observable<any> {

        const formData: FormData = new FormData();
        formData.append('file', file, file.name);

        return this.http.post<any>(`${this.baseUrl}uploadImgForEditor` + this.getDebugParam(), formData, this.getOptions());
    }

    saveTrends(data): Observable<any> {

        return this.http.post<any>(`${this.baseUrl}saveTrends` + this.getDebugParam(), data, this.getOptions());
    }

    getTrends(): Observable<any> {

        return this.http.post<any>(`${this.baseUrl}getTrends` + this.getDebugParam(), this.getOptions());
    }

    publish(data, status): Observable<any> {

        return this.http.post<any>(`${this.baseUrl}publish` + this.getDebugParam(), {
            data: data,
            status: status
        }, this.getOptions());
    }

    getNoticeList(page): Observable<any> {

        return this.http.post<any>(`${this.baseUrl}getNoticeList` + this.getDebugParam(), {
            page: page
        }, this.getOptions());
    }

    getNewsList(page): Observable<any> {

        return this.http.post<any>(`${this.baseUrl}getNewsList` + this.getDebugParam(), {
            page: page
        }, this.getOptions());
    }

    getUserList(page, type): Observable<any> {

        return this.http.post<any>(`${this.baseUrl}getUserList` + this.getDebugParam(), {
            page: page,
            type: type
        }, this.getOptions());
    }


    saveCheckStatus(status, id): Observable<any> {

        return this.http.post<any>(`${this.baseUrl}review/saveCheckStatus` + this.getDebugParam(), {
            id: id,
            status: status
        }, this.getOptions());
    }

    getDataDetail(id): Observable<any> {

        return this.http.post<any>(`${this.baseUrl}review/getDataDetail` + this.getDebugParam(), {
            organId: id
        }, this.getOptions());
    }

    getTableList(data): Observable<any> {

        return this.http.post<any>(`${this.baseUrl}review/getTableList` + this.getDebugParam(), data, this.getOptions());
    }


    getStatistic(page, type): Observable<any> {

        return this.http.post<any>(`${this.baseUrl}getStatistic` + this.getDebugParam(), {
            page: page,
            type: type
        }, this.getOptions());
    }

    getNewsType(): Observable<any> {

        return this.http.post<any>(`${this.baseUrl}getNewsType` + this.getDebugParam(), this.getOptions());
    }

    deleteNewsType(id): Observable<any> {

        return this.http.post<any>(`${this.baseUrl}deleteNewsType` + this.getDebugParam(), {
            id: id
        }, this.getOptions());
    }


    deleteNotice(id): Observable<any> {

        return this.http.post<any>(`${this.baseUrl}deleteNotice` + this.getDebugParam(), {
            id: id
        }, this.getOptions());
    }

    deleteNews(id): Observable<any> {

        return this.http.post<any>(`${this.baseUrl}deleteNews` + this.getDebugParam(), {
            id: id
        }, this.getOptions());
    }


    getMoreNews(page): Observable<any> {

        return this.http.post<any>(`${this.baseUrl}getMoreNews` + this.getDebugParam(), {
            page: page
        }, this.getOptions());
    }

    save(data, type): Observable<any> {

        return this.http.post<any>(`${this.baseUrl}save` + this.getDebugParam(), {
            data: data,
            type: type
        }, this.getOptions());
    }

    isAdministrators(): Observable<any> {

        return this.http.post<any>(`${this.baseUrl}isAdministrators` + this.getDebugParam(), this.getOptions());
    }
}